module.exports = __webpack_public_path__ + "static/media/0321_IMG_LE_PLAFOND_RAL_9010.c60310fa.png";